export async function getCroppedImg(
  imageSrc: string,
  crop: { x: number; y: number; width: number; height: number },
  rotation = 0,
  outputCircle = false,
  fileName = 'cropped.png'
): Promise<File> {
  const image = await new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = imageSrc;
  });

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas not supported');

  // Set canvas to final crop size
  canvas.width = crop.width;
  canvas.height = crop.height;

  // Move, rotate, and draw image
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-canvas.width / 2, -canvas.height / 2);

  ctx.drawImage(
    image,
    crop.x, // start x in image
    crop.y, // start y in image
    crop.width, // width of crop area
    crop.height, // height of crop area
    0,
    0,
    crop.width,
    crop.height
  );

  // Optional circle mask
  if (outputCircle) {
    const mask = document.createElement('canvas');
    mask.width = crop.width;
    mask.height = crop.height;
    const mctx = mask.getContext('2d')!;
    mctx.beginPath();
    mctx.arc(crop.width / 2, crop.height / 2, crop.width / 2, 0, 2 * Math.PI);
    mctx.clip();
    mctx.drawImage(canvas, 0, 0);
    return canvasToFile(mask, fileName);
  }

  return canvasToFile(canvas, fileName);
}

function canvasToFile(canvas: HTMLCanvasElement, fileName: string): Promise<File> {
  return new Promise<File>((resolve, reject) => {
    canvas.toBlob(blob => {
      if (!blob) return reject(new Error('Canvas is empty'));
      resolve(new File([blob], fileName, { type: blob.type || 'image/png' }));
    }, 'image/png');
  });
}
